import {Locale} from '@hebcal/hdate';
import poData from './yi.po.js';
Locale.addLocale('yi', poData);
